import clsx from 'clsx';
import { ComponentProps } from 'react';
import Icon from '~/components/data-display/Icon';
import IconPadlockStarVariant from '~/icons/icon-padlock-star-variant.svg?react';
import styles from './UpsellIcons.module.scss';

interface Props extends Omit<ComponentProps<typeof Icon>, 'component' | 'className'> {
  variant?: boolean;
  animated?: boolean;
  className?: string;
}

const UpsellIconBase: React.FC<Props> = ({ variant, animated, className, ...props }) => (
  <Icon
    size="sm"
    component={IconPadlockStarVariant}
    className={clsx(styles.icon, { [styles.animated!]: animated, [styles.variant!]: variant }, className)}
    {...props}
  />
);

export const UpsellIcon = Object.assign(UpsellIconBase, {
  Variant: (props: Omit<Props, 'variant'>) => <UpsellIconBase {...props} variant />,
  Animated: (props: Omit<Props, 'animated'>) => <UpsellIconBase {...props} animated />,
  VariantAnimated: (props: Omit<Props, 'variant' | 'animated'>) => <UpsellIconBase {...props} variant animated />,
});
